import { render, staticRenderFns } from "./RestDetails.vue?vue&type=template&id=74c4cd1a"
import script from "./RestDetails.vue?vue&type=script&lang=js"
export * from "./RestDetails.vue?vue&type=script&lang=js"
import style0 from "./RestDetails.vue?vue&type=style&index=0&id=74c4cd1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports